import React from 'react'

export const AppleRetailSummaryPage = (): JSX.Element => {
  return <div>AppleRetailSummary</div>
}
